import { useState, FC } from "react";
import {
  Button,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { FiX } from "react-icons/fi";

import { PopupViewer } from "../../../molecules";
import { AddressCard } from "../../../organisms";
import { AddressType } from "../../../../store";

interface Props {
  allAddress: AddressType[];
  address: AddressType;
  setAddress: (a: AddressType) => void;
  title: string;
}

export const AddressSection: FC<Props> = ({
  allAddress,
  address,
  setAddress,
  title,
}) => {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("india");

  const {
    fullName,
    addressLineOne,
    addressLineTwo,
    city,
    state,
    country,
    zipcode,
    mobile,
  } = address;
  return (
    <>
      <Stack gap={1} alignItems="flex-start">
        <Typography variant="subtitle2" fontWeight={700}>
          {title}
        </Typography>
        <Stack gap={1}>
          <Stack gap={1}>
            <Stack direction="row" gap={1}>
              <Typography variant="caption" fontWeight={700}>
                {fullName}
              </Typography>
              <Divider orientation="vertical" flexItem />
              <Typography variant="caption" fontWeight={700}>
                {mobile}
              </Typography>
            </Stack>
            <Typography variant="caption">
              {addressLineOne}, {addressLineTwo}, {city}, {state}, {country},
              {zipcode}
            </Typography>
          </Stack>
          <Button
            size="small"
            variant="outlined"
            sx={{ fontSize: "10px", alignSelf: "flex-start" }}
            onClick={() => setOpen(p => !p)}>
            Change
          </Button>
        </Stack>
      </Stack>
      <PopupViewer open={open} setOpen={setOpen}>
        <div>
          <CardHeader
            title="Select Address"
            titleTypographyProps={{ variant: "subtitle1", fontWeight: 700 }}
            action={
              <IconButton onClick={() => setOpen(false)} size="small">
                <FiX />
              </IconButton>
            }
            subheader={
              <RadioGroup
                row
                value={activeTab}
                onChange={e => setActiveTab(e.target.value)}>
                <FormControlLabel
                  value="india"
                  control={<Radio size="small" />}
                  label="India"
                />
                <FormControlLabel
                  value="rest-of-the-world"
                  control={<Radio size="small" />}
                  label="Rest of the world"
                />
              </RadioGroup>
            }
            sx={{ pb: 0 }}
          />
          <CardContent>
            <Stack gap={3} sx={{ mt: 3 }}>
              {allAddress
                .filter(a => {
                  if (activeTab === "india")
                    return a.country.toLowerCase() === "india";
                  return a.country.toLocaleLowerCase() !== "india";
                })
                .map(a => (
                  <AddressCard
                    key={a.id}
                    address={a}
                    isSelected={a.id === address.id}
                    select={a => {
                      setAddress(a);
                      setOpen(false);
                    }}
                  />
                ))}
            </Stack>
          </CardContent>
        </div>
      </PopupViewer>
    </>
  );
};
